import React from "react";
import "./Sidebar.css";
import { NavLink } from "react-router-dom";
import Logo from "../../assets/Logo.png";
import { useAuth } from "../../AuthProvider";
import AlertPopUp from "../AlertPopUp/AlertPopUp";

const Sidebar = () => {
  const { logout, isStaff } = useAuth();
  const [showPopup, setShowPopup] = React.useState(false);

  const handleLogout = () => {
    setShowPopup(true);
  };

  const navClass = ({ isActive }) =>
    `navLinks-container ${isActive ? "active" : ""}`;

  return (
    <>
      {showPopup && (
        <AlertPopUp
          open={showPopup}
          title="Alert"
          message="Please confirm by clicking Yes to proceed, or No to stay signed in."
          closeButtonText="No"
          buttonText="Yes"
          onAction={() => { logout(); }}
          onClose={() => setShowPopup(false)}
        />
      )}
      <div className="side_bar-container">
        <div className="side_bar-top">
          <div className="linkImg">
            <img className="imageLogo" src={Logo} alt="Logo" />
          </div>

          <div className="side_items">
            <NavLink to="/" className={navClass}>
              <span className="material-symbols-outlined">home</span>
              <div className="title">Home</div>
            </NavLink>

            {!isStaff && (
              <NavLink to="/DashboardDashboardNavigation" className={navClass}>
                <span className="material-symbols-outlined">grid_view</span>
                <div className="title">Dashboard</div>
              </NavLink>
            )}

            <NavLink to="/calendar" className={navClass}>
              <span className="material-symbols-outlined">calendar_month</span>
              <div className="title">Calendar</div>
            </NavLink>

            <NavLink to="/setting" className={navClass}>
              <span className="material-symbols-outlined">settings</span>
              <div className="title bottom">Setting</div>
            </NavLink>

            <NavLink to="/notification" className={navClass}>
              <span className="material-symbols-outlined">notifications</span>
              <div className="title bottom">Notification</div>
            </NavLink>
            <NavLink to="/overview" className={navClass}>
              <span className="material-symbols-outlined">bar_chart_4_bars</span>
              <div className="title bottom">Overview</div>
            </NavLink>
            <NavLink to="/payments" className={navClass}>
              <span className="material-symbols-outlined">receipt</span>
              <div className="title bottom">Payments Status</div>
            </NavLink>
          </div>
        </div>

        <div className="side_bar-bottom">
          <div className="link" onClick={handleLogout}>
            <svg xmlns="http://www.w3.org/2000/svg" className="logout-icon" viewBox="0 0 48 48" fill="none">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 11.5556C8 9.6 9.59964 8 11.5548 8H25.7738V11.5556H11.5548V36.4444H25.7738V40H11.5548C9.59964 40 8 38.4 8 36.4444V11.5556ZM33.1962 22.2222L28.6887 17.7138L31.202 15.2L40 24L31.202 32.8L28.6887 30.2862L33.1962 25.7778H21.4903V22.2222H33.1962Z"
                fill="white"
              />
            </svg>
            <div className="title-logout">Logout</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
